import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { InternshipDetailsListingModel } from 'common/models/page-models/internship-detail/internship-detail-grid.model';
import { InternshipDetailsListModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-data.model';
import { InternshipDetailsGridParams, InternshipDetailsListListingModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-model';


@Injectable({
    providedIn: 'root'
})
export class InternshipDetailsGridDataService extends GridDataService<InternshipDetailsListListingModel, InternshipDetailsListModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.intershipStudentDetails, http, ss);
        // console.log("called")
    }

    // add this for this page API name     [ intershipDetails ]  in place of   IntershipListGrid

    createInstance(): InternshipDetailsListListingModel {
        return new InternshipDetailsListListingModel();
    }

    override getGridParams(param): GridPostParams {
        // console.log(param)
        const payload = new InternshipDetailsGridParams();
        payload.internshipCode = param.internshipCode;
        return payload;
    }
    getDeleteUrl() {
        return '';
    }

    override getDataParam(): string {
        return 'internshipStudent';
    }

    override getExtraParam(): string {
        return 'details';
    }

    override transformDataModel(apiRes: any, param: string) {
        super.transformDataModel(apiRes, param);
        // console.log("API RES", apiRes);
        
        apiRes.details.internshipStudent.forEach((data) => {
            // console.log(data);
            
            data['studentStatus'] = data.isStudentJoined === 1
                ? data.isStudentContinued === 1
                    ? "Continued"
                    : data.isStudentContinued === 2
                        ? "Discontinued"
                        : "Joined"
                : "Not Joined";
            data['internshipStatusByMentor'] = data.internshipStatusByMentor
                ? data.internshipStatusByMentor
                : "-";
            data.certificate = apiRes.internshipCertyPath + data.internshipCertificateFilename;
            data.responseflag = data.isInternshipCertyVerified === 1 ||
                data.isInternshipCertyVerified === 2 ? true : false;
            data.showInternshipCertificate = data.internshipCertificateFilename !== null ? data.isInternshipCertyVerified : null;
        })
       
                apiRes.internshipStudent = apiRes.details.internshipStudent
        return apiRes;
    }

}
